@if (selectedOrder()) {
  <div>
    <div class="flex-row">
      <div class="flex-3">
        <h1 class="submission-type">
          @if (selectedOrder().justDocuments) {
            Non-Standard Order
          } @else {
            Standard Order
          }
        </h1>
        @if (selectedOrder().startedDate) {
          <h2 class="submission-date">Started: {{selectedOrder().startedDate.toLocaleDateString()}}</h2>
        }
        @if (selectedOrder().submissionDate) {
          <h2 class="submission-date">Submitted: {{selectedOrder().submissionDate.toLocaleDateString()}}</h2>
        }
        @if (selectedOrder().FlandersID) {
          <h2 class="submission-date">Flanders Order ID: {{selectedOrder().FlandersID}}</h2>
        }
        @if (selectedOrder().SwordsID) {
          <h2 class="submission-date">Swords Order ID: {{selectedOrder().SwordsID}}</h2>
        }
      </div>
    </div>
    <div class="metadata-section">
      <div class="flex-row">
        <div class="flex-1 form-section">
          <div class="form-row">
            <h2>Order Title<span class="required-field">*</span></h2>
            @if (!selectedOrder().status) {
              <h2 class="title-input">{{selectedOrder().name}}</h2>
            } @else {
              <div class="flex-row">
                <input id="order-title-input" class="input title-input" type="text" [(ngModel)]="selectedOrder().name" (change)="markAsUnsaved()">
              </div>
            }
          </div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-1 form-section">
          <h2>Contact Info</h2>
          <div class="form-row">
            <div class="flex-row label-row">
              <label class="flex-1">Name<span class="required-field">*</span></label>
            </div>
            <div class="flex-row">
              <input id="contact-name-input" class="input input-sm flex-1" type="text" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().contactName" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
            </div>
          </div>
          <div class="form-row">
            <div class="flex-row label-row">
              <label class="flex-1">Email<span class="required-field">*</span></label>
            </div>
            <div class="flex-row">
              <input id="contact-email-input" class="input input-sm flex-1" type="email" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().contactEmail" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
            </div>
          </div>
          <div class="flex-row ">
            <div class="form-row">
              <div class="flex-row label-row">
                <label class="flex-1">Comments@if (selectedOrder().resubmission) {
                  <span class="required-field">*</span>
                }</label>
              </div>
              <div class="flex-row">
                <textarea id="comments-input" class="input input-textarea flex-1" type="textarea" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().comments" [attr.disabled]="!selectedOrder().status ? 'disabled' : null"> </textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 form-section">
          <h2>Product Info</h2>
          <div class="form-row">
            <div class="flex-row label-row">
              <label class="flex-1" id="smn_label">SMN<span class="required-field">*</span></label>
              <span class="gutter"></span>
              <label class="flex-1">SMN Revision<span class="required-field">*</span></label>
            </div>
            <div class="flex-row">
              <input id="smn-input" class="input input-sm flex-1" type="text" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().SMN" [attr.disabled]="!selectedOrder().status ? 'disabled' : null" id="smn-input"/>
              <span class="gutter"></span>
              <input id="revision-number-input" class="input input-sm flex-1" type="text" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().revisionNumber" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
            </div>
          </div>
          @if (!selectedOrder().justDocuments) {
            <div class="form-row">
              <div class="flex-row label-row">
                <label class="flex-1">Quantity<span class="required-field">*</span></label>
                <span class="gutter"></span>
                <label class="flex-1">Ship Date<span class="required-field">*</span></label>
              </div>
              <div class="flex-row">
                <input id="quantity-input" class="input input-sm flex-1" type="number" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().quantity" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
                <span class="gutter"></span>
                <input id="ship-date-input" class="input input-sm flex-1" type="date" value="mm/dd/yyyy" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().shipDate" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
              </div>
            </div>
          }
          <br>
            <p>Sites</p>
            <div class="flex-row row-section">
              <table id="site-table" class="site-table">
                <tr>
                  <td>
                    <div class="site-checkbox">
                      <mat-checkbox class="site-checkbox-control" id="flanders" name="flanders" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().selectFlanders" [disabled]="!selectedOrder().status">Flanders, NJ</mat-checkbox>
                    </div>
                  </td>
                  @if (selectedOrder().selectFlanders && !selectedOrder().justDocuments) {
                    <td>
                      <div class="po-input">
                        <label for="flandersPOBox">PO:<span class="required-field">*</span> </label>
                        <input id="flandersPOBox" class="input input-sm flex-1" type="text" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().FlandersPO" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
                      </div>
                    </td>
                  }
                </tr>
                <tr>
                  <td>
                    <div class="site-checkbox">
                      <mat-checkbox class="site-checkbox-control" id="swords" name="swords" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().selectSwords" [disabled]="!selectedOrder().status">Swords, Ireland</mat-checkbox>
                    </div>
                  </td>
                  @if (selectedOrder().selectSwords && !selectedOrder().justDocuments) {
                    <td>
                      <div class="po-input">
                        <label for="swordsPOBox">PO:<span class="required-field">*</span> </label>
                        <input id="swordsPOBox" class="input input-sm flex-1" type="text" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().SwordsPO" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
                      </div>
                    </td>
                  }
                </tr>
                <tr>
                  <td>
                    <div class="site-checkbox">
                      <mat-checkbox class="site-checkbox-control" id="llanberis" name="llanberis" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().selectLlanberis" [disabled]="!selectedOrder().status">Llanberis, UK</mat-checkbox>
                    </div>
                  </td>
                  @if (selectedOrder().selectLlanberis && !selectedOrder().justDocuments) {
                    <td>
                      <div class="po-input">
                        <label for="LlanberisPOBox">PO:<span class="required-field">*</span> </label>
                        <input id="LlanberisPOBox" class="input input-sm flex-1" type="text" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().LlanberisPO" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
                      </div>
                    </td>
                  }
                </tr>
                <tr>
                  <td>
                    <div class="site-checkbox">
                      <mat-checkbox class="site-checkbox-control" id="las-angeles" name="las-angeles" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().selectLasAngeles" [disabled]="!selectedOrder().status">Los Angeles, California</mat-checkbox>
                    </div>
                  </td>
                  @if (selectedOrder().selectLasAngeles && !selectedOrder().justDocuments) {
                    <td>
                      <div class="po-input">
                        <label for="LasAngelesPOBox">PO:<span class="required-field">*</span> </label>
                        <input id="LasAngelesPOBox" class="input input-sm flex-1" type="text" (change)="markAsUnsaved()" [(ngModel)]="selectedOrder().LasAngelesPO" [attr.disabled]="!selectedOrder().status ? 'disabled' : null">
                      </div>
                    </td>
                  }
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      @if (selectedOrder().justDocuments) {
        <div class="flex-row row-section">
          <div class="flex-4 site-section">
            <label id="site-radio-group-label-1">Is this a Request For Quotation? <span class="required-field">*</span></label>
            <mat-radio-group
              aria-labelledby="site-radio-group-label-1"
              class="site-radio-group"
              (change)="markAsUnsaved()"
              [(ngModel)]="selectedOrder().requestForQuotation">
              <mat-radio-button class="site-radio-button" [value]="true" [disabled]="!selectedOrder().status"> Yes </mat-radio-button>
              <mat-radio-button class="site-radio-button" [value]="false" [disabled]="!selectedOrder().status"> No </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      }
      @if (!selectedOrder().justDocuments) {
        <div class="flex-row row-section">
          <div class="flex-4 site-section">
            <label id="site-radio-group-label-2">Is this the first shipment of the SMN to Siemens? <span class="required-field">*</span></label>
            <mat-radio-group
              id="question-1-radio-input"
              class="site-radio-group"
              (change)="markAsUnsaved()"
              [(ngModel)]="selectedOrder().question1Response">
              <mat-radio-button class="site-radio-button" [value]="true" [disabled]="!selectedOrder().status"> Yes </mat-radio-button>
              <mat-radio-button class="site-radio-button" [value]="false" [disabled]="!selectedOrder().status"> No </mat-radio-button>
            </mat-radio-group>
            <br>
              <label id="site-radio-group-label-3">Is this the first shipment of this SMN revision to Siemens? <span class="required-field">*</span></label>
              <mat-radio-group
                id="question-2-radio-input"
                class="site-radio-group"
                (change)="markAsUnsaved()"
                [(ngModel)]="selectedOrder().question2Response">
                <mat-radio-button class="site-radio-button" [value]="true" [disabled]="!selectedOrder().status"> Yes </mat-radio-button>
                <mat-radio-button class="site-radio-button" [value]="false" [disabled]="!selectedOrder().status"> No </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        }
        <hr>
          <div class=" document-center">
            @for (type of documentTypes; track type) {
              <div class="document-section">
                @if (canUpload(type)) {
                  <div class="document-item">
                    <app-document-uploader [order]="selectedOrder()" [documentType]="type"></app-document-uploader>
                  </div>
                }
              </div>
            }
          </div>
          <div class="flex-row row-section">
            <div class="flex-2"></div>
            <div class="flex-2 action-section">
              <div class="flex-row">
                <div class="flex-1 action-button delete-button" (click)="promptDeleteOrder()"> DELETE </div>
                <span class="gutter"></span>
                <div class="flex-1 action-button clone-button" (click)="cloneOrder()"> CLONE </div>
                <span class="gutter"></span>
                @if (selectedOrder().status) {
                  <div class="flex-1 action-button save-button" (click)="saveOrder()"> SAVE </div>
                }
                <span class="gutter"></span>
                @if (selectedOrder().status) {
                  <div id="submit-button" class="flex-1 action-button submit-button" (click)="submitOrder()"> SUBMIT </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
